import React from "react";
import IconAction from "../../../../shared/components/generic/button/icon-action/icon-action";

export const holidayColumnsConfig = ({ onEdit, onDelete }) => [
	{
		key: "name",
		label: "Nome do feriado",
		render: row => row.name || "-"
	},
	{
		key: "date",
		label: "Data",
		render: row => (
			<span className="holiday-management__date">
				{row.dateLabel}
			</span>
		)
	},
	{
		key: "actions",
		label: "Ações",
		render: row => (
			<IconAction
				row={row}
				actions={[
					{
						key: "edit",
						variant: "edit",
						title: "Editar",
						ariaLabel: "Editar feriado",
						onClick: onEdit
					},
					{
						key: "delete",
						variant: "delete",
						title: "Excluir",
						ariaLabel: "Excluir feriado",
						onClick: onDelete
					}
				]}
			/>
		)
	}
];